/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as TooltipDefault } from './tooltip-default.story';
export { default as TooltipDisabled } from './tooltip-disabled.story';
export { default as TooltipControlled } from './tooltip-controlled.story';
export { default as TooltipInitialOpen } from './tooltip-initial-open.story';
export { default as TooltipPlacements } from './tooltip-placements.story';
export { default as TooltipInDialog } from './tooltip-in-dialog.story';
export { default as TooltipHoverDelay } from './tooltip-hover-delay.story';
export { default as TooltipTriggerButtonWrapper } from './tooltip-trigger-button-wrapper.story';
export { default as TooltipRich } from './tooltip-rich.story';
export { default as TooltipRichActions } from './tooltip-rich-actions.story';
export { default as TooltipRichLink } from './tooltip-rich-link.story';
export { default as TooltipWithKeyboardDisplay } from './tooltip-with-keyboard-display.story';
export { default as TooltipFollowCursor } from './tooltip-follow-cursor.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import TooltipControlledSourceRaw from './tooltip-controlled.story?raw';
import TooltipDefaultSourceRaw from './tooltip-default.story?raw';
import TooltipDisabledSourceRaw from './tooltip-disabled.story?raw';
import TooltipFollowCursorSourceRaw from './tooltip-follow-cursor.story?raw';
import TooltipHoverDelaySourceRaw from './tooltip-hover-delay.story?raw';
import TooltipInDialogSourceRaw from './tooltip-in-dialog.story?raw';
import TooltipInitialOpenSourceRaw from './tooltip-initial-open.story?raw';
import TooltipPlacementsSourceRaw from './tooltip-placements.story?raw';
import TooltipRichSourceRaw from './tooltip-rich.story?raw';
import TooltipRichActionsSourceRaw from './tooltip-rich-actions.story?raw';
import TooltipRichLinkSourceRaw from './tooltip-rich-link.story?raw';
import TooltipTriggerButtonWrapperSourceRaw from './tooltip-trigger-button-wrapper.story?raw';
import TooltipWithKeyboardDisplaySourceRaw from './tooltip-with-keyboard-display.story?raw';

export const TooltipDefaultSource = removeLicenseHeader(
  TooltipDefaultSourceRaw,
);
export const TooltipDisabledSource = removeLicenseHeader(
  TooltipDisabledSourceRaw,
);
export const TooltipControlledSource = removeLicenseHeader(
  TooltipControlledSourceRaw,
);
export const TooltipInitialOpenSource = removeLicenseHeader(
  TooltipInitialOpenSourceRaw,
);
export const TooltipPlacementsSource = removeLicenseHeader(
  TooltipPlacementsSourceRaw,
);
export const TooltipInDialogSource = removeLicenseHeader(
  TooltipInDialogSourceRaw,
);
export const TooltipHoverDelaySource = removeLicenseHeader(
  TooltipHoverDelaySourceRaw,
);
export const TooltipRichSource = removeLicenseHeader(TooltipRichSourceRaw);
export const TooltipRichActionsSource = removeLicenseHeader(
  TooltipRichActionsSourceRaw,
);
export const TooltipRichLinkSource = removeLicenseHeader(
  TooltipRichLinkSourceRaw,
);
export const TooltipWithKeyboardDisplaySource = removeLicenseHeader(
  TooltipWithKeyboardDisplaySourceRaw,
);
export const TooltipTriggerButtonWrapperSource = removeLicenseHeader(
  TooltipTriggerButtonWrapperSourceRaw,
);
export const TooltipFollowCursorSource = removeLicenseHeader(
  TooltipFollowCursorSourceRaw,
);
